<script>
export default {
    data() {
        return {
            openedTabs: []
        };
    },
    props: {
        tabs: {
            type: Array,
            default:() => []
        },
        defaultOpen: {
            type: Array,
            default:() => []
        },
        showAccordionControl: {
            type: Boolean,
            default: () => true
        }
    },
    methods: {
        isActive(item = "") {
            return (
                this.tabs.indexOf(item) >= 0 &&
                this.openedTabs.indexOf(item) >= 0
            );
        },
        toggleItem(item = "") {
            if (this.tabs.indexOf(item) >= 0) {
                let itemIndex = this.openedTabs.indexOf(item);
                if (itemIndex >= 0) {
                    this.openedTabs.splice(itemIndex, 1);
                } else {
                    this.openedTabs.push(item);
                }
            }
        }
    },
    mounted() {
        if(this.defaultOpen.length === 0){
            if(this.tabs.length > 0){
                this.openedTabs.push(this.tabs[0]);
            }
        }else{
            this.default.forEach(element => {
                this.openedTabs.push(element);
            });
        }
    },
    computed: {}
};
</script>

<style lang="scss" scoped>
.accordion {
    .card {
        .card-title {
            cursor: pointer;
        }
    }
}
.pull-enter-active,
.pull-leave-active {
    transition: all .5s;
}
.pull-enter, .pull-leave-to /* .fade-leave-active below version 2.1.8 */ {
    transform: translate(0%, -10%);
    opacity: 0;
}
</style>
